/** @format */

import {
	Button,
	Center,
	Divider,
	Flex,
	useStyleConfig,
	Link,
	Box,
	Text,
	Spacer,
} from '@chakra-ui/react';
import {colors} from '../../../styles/js/colors';
import {textStyles} from '../../../styles/js/textStyles';
import {
	TopCardProps,
	PricingProps,
	TickBulletsProps,
	TextSectionProps,
	MarketingPackageAccordionProps,
	TopCard,
	Pricing,
	TextSection,
	TickBullets,
	MarketingPackageAccordion,
} from './PackageCardElements';

export const PackageCard = ({
	topCard,
	pricing,
	bullets,
	textSections,
	marketingPackageAccordion,
	memberPackage,
	cta,
}: {
	topCard: TopCardProps;
	pricing?: PricingProps;
	bullets?: TickBulletsProps;
	textSections?: TextSectionProps[];
	marketingPackageAccordion?: MarketingPackageAccordionProps;
	memberPackage?: string;
	cta?: {
		target?: string;
		url: string;
		title: string;
	};
}) => {
	const buttonStyle = useStyleConfig('Button', {variant: 'secondary'});
	return (
		<Flex
			borderRadius={8}
			backgroundColor={colors.arctic}
			boxShadow='lg'
			w={{base: '100%', md: '16.5rem'}}
			minH='60rem'
			flexGrow='1'
			flexDirection='column'
			justifyContent='flex-start'>
			<TopCard
				text={{
					heading: topCard.text.heading,
					body: topCard.text.body,
				}}
				backgroundColor={topCard.backgroundColor}
			/>
			{pricing && (
				<>
					<Pricing
						joiningFee={pricing.joiningFee / 100}
						annualFee={pricing.annualFee / 100}
					/>
					<Divider variant='primary' />
				</>
			)}
			{textSections?.map((textSection, index) => (
				<>
					<Box py={4} px={6} minH='13.5rem' key={textSection.heading.concat(index.toString())}>
						<TextSection {...textSection} />
					</Box>
					<Divider variant='primary' />
				</>
			))}
			{bullets && (
				<>
					<Box p={6}>
						<TickBullets bullets={bullets.bullets} />
					</Box>
					{!marketingPackageAccordion && <Divider variant='primary' />}
				</>
			)}
			{marketingPackageAccordion && (
				<MarketingPackageAccordion
					packageInfo={marketingPackageAccordion.packageInfo}
					bullets={marketingPackageAccordion.bullets}
					pricing={marketingPackageAccordion.pricing}
				/>
			)}
			<Spacer></Spacer>
			<Center>
				{cta ? (
					<Link href={cta.url} sx={buttonStyle} w='100%' m={6}>
						<Text sx={textStyles.paragraph1LeftDark}>{cta.title}</Text>
					</Link>
				) : (
					<Link
						href={`/join-the-assc/join?memberPackage=${memberPackage}`}
						sx={buttonStyle}
						w='100%'
						m={6}>
						<Text sx={textStyles.paragraph1LeftDark}>Join Today</Text>
					</Link>
				)}
			</Center>
		</Flex>
	);
};

export default PackageCard;
